(() => {
  const digits = value => value.replace(/\D/g, '');
  function validCpf(value) {
    if (!/^\d{11}$/.test(value) || /^(\d)\1{10}$/.test(value)) return false;
    for (let length = 9; length <= 10; length++) {
      let sum = 0;
      for (let i = 0; i < length; i++) sum += Number(value[i]) * (length + 1 - i);
      const check = (sum * 10 % 11) % 10;
      if (check !== Number(value[length])) return false;
    }
    return true;
  }
  function initialize(form) {
    if (form.dataset.initialized) return;
    const cpf = form.querySelector('[data-tracking-cpf]');
    const cep = form.querySelector('[data-tracking-cep]');
    const cpfError = form.querySelector('[data-tracking-cpf-error]');
    const cepError = form.querySelector('[data-tracking-cep-error]');
    const status = form.querySelector('[data-tracking-status]');
    if (!cpf || !cep || !cpfError || !cepError || !status) return;
    form.dataset.initialized = 'true';
    form.noValidate = true;
    const error = (field, message, text) => {
      message.textContent = text;
      if (text) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };
    const clearResult = () => status.replaceChildren();
    cpf.addEventListener('input', () => {
      const value = digits(cpf.value).slice(0, 11);
      cpf.value = value.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
      error(cpf, cpfError, ''); clearResult();
    });
    cep.addEventListener('input', () => {
      cep.value = digits(cep.value).slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2');
      error(cep, cepError, ''); clearResult();
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      clearResult();
      const document = digits(cpf.value);
      const postcode = digits(cep.value);
      const cpfMessage = validCpf(document) ? '' : form.dataset.cpfError || 'Informe um CPF válido com 11 dígitos.';
      const cepMessage = /^\d{8}$/.test(postcode) ? '' : form.dataset.cepError || 'Informe o CEP da entrega com 8 dígitos.';
      error(cpf, cpfError, cpfMessage); error(cep, cepError, cepMessage);
      if (cpfMessage || cepMessage) {
        status.textContent = form.dataset.validationError || 'Confira os campos indicados antes de rastrear.';
        (cpfMessage ? cpf : cep).focus();
        return;
      }
      // Public result route observed in Frete Barato's own form on 2026-10-06.
      // No network request on input, no API token, no local/session storage.
      const url = 'https://rastreamentofb.com.br/rastrear/resultado/v2/' + document + '/' + postcode;
      const link = window.document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.referrerPolicy = 'no-referrer';
      link.textContent = form.dataset.fallbackLabel || 'Se a nova aba não abrir, abra a consulta por este link.';
      status.append(link);
      // Synchronous user gesture: browser opens the same page used by the service.
      link.click();
    });
    form.hidden = false;
  }
  const initializeAll = root => {
    if (root.matches?.('[data-dm-tracking-form]')) initialize(root);
    root.querySelectorAll('[data-dm-tracking-form]').forEach(initialize);
  };
  initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
